
// This file is generated. Don't modify it.
import React from 'react'
export default function CheckboxIndetermIcon (props) {

    const { color } = props
    
    return (
                
        <svg width="1em" height="1em" viewBox="0 0 16 16">
            <defs>
                <path d="M2,2 L14,2 L14,14 L2,14 L2,2 Z M11.75,8.75 L11.75,7.25 L4.25,7.25 L4.25,8.75 L11.75,8.75 Z" id="CheckboxIndetermIcon-path-1"></path>
            </defs>
            <g id="Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Iconology" transform="translate(-144.000000, -348.000000)">
                    <g id="Icon/Checkbox" transform="translate(48.000000, 348.000000)">
                        <g id="Icon/Checkbox/Indeterminate" transform="translate(96.000000, 0.000000)">
                            <g id="Group-3">
                                <rect id="16px-Bounding-Box" stroke="none" fill="none" fillRule="nonzero" x="0.5" y="0.5" width="15" height="15"></rect>
                                <mask id="CheckboxIndetermIcon-mask-2" fill="white">
                                    <use href="#CheckboxIndetermIcon-path-1"></use>
                                </mask>
                                <use id="Combined-Shape" fill={color} href="#CheckboxIndetermIcon-path-1"></use>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
